import { PatientKeyFields } from '~/features/intake/patients/PatientKeyFields';
import { VisitAddress } from '~/features/demographics/addresses/visit-address/VisitAddress';
import { StartOfCareSchedule } from '~/features/scheduling/schedules/StartOfCareSchedule';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAdmissionOptions } from '@generated';
import { getCertificationPeriod, getDayOfStay } from '~/features/intake/util';
import { CertificationPeriodsSchedule } from '~/features/scheduling/cert-periods/CertificationPeriodsSchedule';
import { useChart } from '~/features/admissions/charts/ChartContext';

const now = new Date();
export function PatientOverviewRoute() {
	const { stayId } = useChart();
	const { data: admission } = useSuspenseQuery(getAdmissionOptions(stayId));
	const certPeriod = getCertificationPeriod(admission.certificationPeriods, now);
	const lastCertPeriod = admission.certificationPeriods.toSorted((a, b) => b.certificationNumber - a.certificationNumber)[0];
	const certificationPeriodToShow = certPeriod ? certPeriod : lastCertPeriod;

	const dayOfStay = getDayOfStay(admission.startOfCareDate, now);

	return (
		<div className="grid grid-cols-2 gap-4">
			<div className="col-span-2">
				{dayOfStay <= 5 ? (
					<StartOfCareSchedule stayId={stayId} />
				) : (
					<CertificationPeriodsSchedule certificationPeriod={certificationPeriodToShow} />
				)}
			</div>
			<PatientKeyFields />
			<VisitAddress stayId={stayId} />
		</div>
	);
}
